module.exports = __webpack_public_path__ + "img/RAQ-not-eligible-img-desktop-only.de4c2562.png";